import { useEffect, useState } from "preact/hooks";

function readFlag(): boolean {
  if (typeof window === "undefined") return false;
  return new URLSearchParams(window.location.search).get("link") === "invalid";
}

/**
 * Sprint-007 D6 (ADR-002 A4-R6, UX §3.4) — `GET /m/{token}` now 302s a
 * dead (expired/consumed/revoked) link to the single literal
 * `/?link=invalid` — no reason taxonomy; the no-enumeration contract
 * forbids distinguishing AMONG invalid reasons, not hiding validity
 * itself — and sets no session cookie.
 *
 * Reads the flag ONCE off `location.search` on initial SPA load (lazy
 * `useState` initializer, not an effect, so the very first render already
 * knows) and immediately scrubs `?link=invalid` from the URL/history —
 * this is a one-time landing message, not a persistent route; a refresh,
 * bookmark, or share of this exact URL must not keep re-showing the
 * token-invalid screen forever.
 */
export function useTokenInvalidFlag(): boolean {
  const [invalid] = useState(readFlag);

  useEffect(() => {
    if (!invalid) return;
    const url = new URL(window.location.href);
    url.searchParams.delete("link");
    window.history.replaceState(null, "", `${url.pathname}${url.search}${url.hash}`);
  }, [invalid]);

  return invalid;
}
